import { render, staticRenderFns } from "./ContractDetailsModal.vue?vue&type=template&id=be1966c2&scoped=true"
import script from "./ContractDetailsModal.vue?vue&type=script&lang=js"
export * from "./ContractDetailsModal.vue?vue&type=script&lang=js"
import style1 from "./ContractDetailsModal.vue?vue&type=style&index=1&id=be1966c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be1966c2",
  null
  
)

export default component.exports